import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useYesNoTranslation = () => {
  const { t } = useTranslation();

  const yesNoTranslation = useCallback((value: boolean) => (value ? t('common.yes') : t('common.no')), [t]);

  return {
    yesNoTranslation,
  };
};
